import styled from '@emotion/styled'

export const StyledContent = styled('div')`
  min-width: 100%;
  overflow: hidden;
  position: relative;
`

export default { StyledContent }
